import React from "react";
import { useNavigate } from "react-router-dom";
import Confirm_Modal from "../../Common/Common_Component/Common_Modal/Confirm_Modal/Confirm_Modal";

function BottomNav() {
  const [modalShow, setModalShow] = React.useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    setModalShow(true);

    setTimeout(() => {
      setModalShow(false);
      navigate("/login");
    }, 3000);
  };

  return (
    <>
      <div className="bottom-nav">
        <button className="btn-register" onClick={handleLogout}>
          Log out
        </button>
      </div>

      <Confirm_Modal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default BottomNav;